/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from 'react';
import {
  Avatar,
  Collapse,
  Divider,
  IconButton,
  Icon,
  Grid,
  ListItem,
  ListItemAvatar,
  Typography,
  withStyles,
} from '@material-ui/core';
import parse from 'html-react-parser';
import { IconUI, ToggleUI } from '../../common';

const HtmlDecode = ({ input }) => {
  input = input.split('<p><br></p>').join('<br>');
  input = input.split('<br><br>').join('<br>');
  if (input.slice(-4) === '<br>') {
    input = input.slice(0, -4);
  }
  return parse('<div class="ql-container">' + input + '</div>');
};

const ArticulosEventWrapper = ({ articulo, children, handleNestedMenu }) => {
  return (
    <div style={{ width: '100%' }}>
      <ToggleUI show={articulo.type === 1}>
        <a href={articulo.content} target="_blank" style={{ width: '100%' }}>
          {children}
        </a>
      </ToggleUI>
      <ToggleUI show={articulo.type === 0}>
        <a
          href="#!"
          target="_blank"
          style={{ width: '100%' }}
          onClick={(e) => {
            e.preventDefault();
            handleNestedMenu();
          }}
        >
          {children}
        </a>
      </ToggleUI>
    </div>
  );
};

const ArticulosListItem_ = (props) => {
  let { articulos, articulo, index, classes } = props;

  const [nestedMenuStatus, setNestedMenuStatus] = useState(false);

  const handleNestedMenu = () => setNestedMenuStatus(!nestedMenuStatus);

  return (
    <ListItem
      divider={index < articulos.length - 1}
      key={articulo.slug}
      classes={{ root: classes.list_item }}
    >
      <Grid container spacing={8}>
        <Grid item xs={12}>
          <ArticulosEventWrapper
            articulo={articulo}
            handleNestedMenu={handleNestedMenu}
          >
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
              spacing={8}
            >
              <Grid item xs={9}>
                <Grid container alignItems="center" spacing={8}>
                  <ToggleUI show={articulo.icon ? true : false}>
                    <Grid item>
                      <ListItemAvatar>
                        <Avatar className={classes.avatar}>
                          <IconUI
                            name={articulo.icon}
                            style={{
                              fontSize: '1rem',
                              textAlign: 'center',
                            }}
                          />
                        </Avatar>
                      </ListItemAvatar>
                    </Grid>
                  </ToggleUI>
                  <Grid item>
                    <Typography className={classes.list_item_title}>
                      {articulo.title}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <ToggleUI show={articulo.type === 1 ? true : false}>
                  <IconButton aria-label="Aceptar">
                    <Icon
                      style={{
                        fontSize: '1.5rem',
                        textAlign: 'center',
                        padding: '2px',
                      }}
                    >
                      navigate_next
                    </Icon>
                  </IconButton>
                </ToggleUI>
                <ToggleUI show={articulo.type === 0 ? true : false}>
                  <IconButton aria-label="Aceptar">
                    <Icon className={classes.list_item_menu_icon}>
                      {nestedMenuStatus ? 'expand_less' : 'navigate_next'}
                    </Icon>
                  </IconButton>
                </ToggleUI>
              </Grid>
            </Grid>
          </ArticulosEventWrapper>
        </Grid>
        <ToggleUI show={articulo.type === 0 && nestedMenuStatus ? true : false}>
          <Grid item xs={12}>
            <Collapse in={nestedMenuStatus} timeout="auto" unmountOnExit>
              <Grid container spacing={24}>
                <Grid item xs={12}>
                  <Divider />
                  <div className={classes.wrapper}>
                    <HtmlDecode input={articulo.content} />
                  </div>
                </Grid>
              </Grid>
            </Collapse>
          </Grid>
        </ToggleUI>
      </Grid>
    </ListItem>
  );
};

const styles = (theme) => ({
  list: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    padding: '0',
    '&:last-child': {
      borderBottom: '0px solid transparent',
    },
  },
  list_item: {
    padding: '5px 0px 5px 0px',
  },
  list_item_title: {
    fontSize: '1rem',
    fontWeight: '500',
    marginLeft: '10px',
    marginBottom: '0px',
    padding: '0px',
  },
  avatar: {
    marginLeft: '10px',
  },
  wrapper: {
    boxSizing: 'border-box',
    padding: '15px',
  },
});

export const ArticulosListItem = withStyles(styles, { withTheme: true })(
  ArticulosListItem_
);
